import { render } from "./NotFound.vue?vue&type=template&id=63f13a82&scoped=true&ts=true"
import script from "./NotFound.vue?vue&type=script&lang=ts"
export * from "./NotFound.vue?vue&type=script&lang=ts"

import "./NotFound.vue?vue&type=style&index=0&id=63f13a82&scoped=true&lang=css"

import exportComponent from "/builds/tmobile/tss/projects/esd/common/techapps-host-ext/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f13a82"]])

export default __exports__